module.exports = __webpack_public_path__ + "img/image10.7ad1fc64.jpg";